import { Box, Button, Modal, Paper, Stack, Typography } from "@mui/material";
import { ReactNode, useEffect } from "react";
import { useAppSelector, useAppDispatch } from "../../../../app/hooks";
import { homeworkDelete, HomeworkDeleteRequest, homeworkInsUpdSlice, selectHomeworkInsUpd } from "../../../../redux/homework/homeworkInsUpdSlice";
import { HomeworkInfo } from "../../../../redux/homework/homeworkSlice";
import { LoadState } from "../../../../redux/common";

interface ModalProps {
    open: boolean;
    onClose: (success: boolean) => void;
    homework: HomeworkInfo;
}

const HomeworkDeleteModal = ({ open, onClose, homework }: ModalProps) => {
    const homeworkInsUpd = useAppSelector(selectHomeworkInsUpd);
    const dispatch = useAppDispatch();

    useEffect(() => {
        dispatch(homeworkInsUpdSlice.actions.clean());
    }, []);
    useEffect(() => {
        if (homeworkInsUpd.state.state === LoadState.Loaded) {
            dispatch(homeworkInsUpdSlice.actions.clean());
            onClose(true);
        }
    }, [homeworkInsUpd, onClose]);

    const confirmed = () => {
        const request: HomeworkDeleteRequest = {
            homeworkId: homework.id
        };
        dispatch(homeworkDelete(request));
    };

    return <Modal open={open} onClose={() => onClose(false)} sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
        <Paper sx={{ p: 4, minWidth: 320 }}>
            <Stack spacing={2} alignItems="center">
                <Typography variant="h6">Remover Tarefa</Typography>
                <Typography variant="body1">Tem certeza que deseja remover a tarefa <b>{homework.name}</b>?</Typography>
                <Stack direction="row" spacing={2}>
                    <Button variant="contained" color="error" onClick={() => confirmed()}>Remover</Button>
                    <Button variant="contained" onClick={() => onClose(false)}>Cancelar</Button>
                </Stack>
            </Stack>
        </Paper>
    </Modal>;
};

export default HomeworkDeleteModal;
